import React from 'react';
import { motion } from 'framer-motion';
import { FaDesktop, FaRocket } from 'react-icons/fa';
import ScrollReveal from './ScrollReveal';

const ServicesSection = () => {
  const services = [
    {
      icon: <FaRocket className="text-4xl text-secondary" />,
      title: 'דפי נחיתה',
      description: 'החלון לעסק שלך, מטרתו למשוך לקוחות בעזרת עמוד פשוט, מקצועי וממוקד'
    },
    {
      icon: <FaDesktop className="text-4xl text-secondary" />,
      title: 'אתרי תדמית',
      description: 'הפנים הדיגיטליות שלך במספר עמודים המציגים את פעילות ותדמית העסק'
    }
  ];

  return (
    <section id="services" className="section-padding text-white relative mt-24 sm:mt-96">
      <div className="container mx-auto px-4 relative z-10">
        <ScrollReveal>
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="section-title text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
              השירותים שלנו
            </h2>
            <div className="accent-line bg-cta"></div>
          </div>
        </ScrollReveal>

        <div className="grid md:grid-cols-2 gap-4 sm:gap-8 md:gap-12 max-w-6xl mx-auto">
          {services.map((service, index) => (
            <ScrollReveal key={index} delay={index * 0.2}>
              <motion.div
                whileHover={{ y: -8, scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="bg-white/5 backdrop-blur-sm p-6 sm:p-8 md:p-10 rounded-xl border border-white/10 hover:border-white/20 hover:bg-white/10 transition-all duration-300 h-full"
              >
                <div className="flex flex-col items-center text-center h-full">
                  <motion.div
                    whileHover={{ rotate: 360 }}
                    transition={{ duration: 0.6 }}
                    className="w-16 sm:w-20 md:w-24 h-16 sm:h-20 md:h-24 bg-white/10 rounded-full flex items-center justify-center mb-4 sm:mb-6 md:mb-8 group-hover:bg-secondary/20 transition-all duration-300"
                  >
                    {service.icon}
                  </motion.div>
                  <h3 className="text-lg sm:text-xl md:text-2xl font-semibold text-white mb-3 sm:mb-4 md:mb-6">
                    {service.title}
                  </h3>
                  <p className="text-sm sm:text-base md:text-lg text-gray-300 leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </motion.div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection; 